import React, { Suspense, useEffect, useState } from 'react';
import { data, useNavigate, useParams } from 'react-router';
import CircularProgress from '@mui/material/CircularProgress';
import { dataSection } from '../../../contant';
import { APIServices } from '../../../hooks/fetchAPI';
import { useSelector } from 'react-redux';
import { pageRoutes } from '../../../routes/pageRoutes';

const OnBoardingGuidelines = React.lazy(() => import('./OnBoardingGuidelines'));
const OnBoardingTab = React.lazy(() => import('./OnBoardingTab'));
const ExamList = React.lazy(() => import('../Exam/ExamList'));

function OnBoardingExam() {
    const { id } = useParams();
    const user = useSelector((state) => state.user.userData)
    const navigate = useNavigate();
    const [showGuidelines, setShowGuidelines] = useState(true);
    const [onBoardingId, setOnBoardingId] = useState(0);
    const [activeStep, setActiveStep] = useState(parseFloat(id));
    const [moduleListData, setModuleListData] = useState([]);
    const [selectedModule, setSelectedModule] = useState(null);
    const [mcqData, setMcqData] = useState([]);
    const [reflectionData, setReflectionData] = useState([]);
    const [videoQuality, setVideoQuality] = useState('360');
    const [isLoading, setIsLoading] = useState(false);


    const moduleStatus = async () => {
        try {
            const response = await APIServices.get({ url: `/onboarding/current-module/${user?.id}` });
            if (response && response.status === 200) {
                const currentModule = response?.data?.modules?.find(module => module.is_current);
                if (currentModule) {
                    setOnBoardingId(currentModule.module_id);
                    if (parseFloat(id) !== onBoardingId) {
                        navigate(`/onboarding-exam/${currentModule.module_id}`);
                        return;
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        }
    };


    const moduleList = async () => {
        setIsLoading(true);
        try {
            const response = await APIServices.get({ url: `/onboarding/modules`, payload: { quality: videoQuality } });
            if (response && response.status === 200) {
                setModuleListData(response?.data || []);

            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const mcqExam = async () => {
        try {
            const response = await APIServices.get({ url: `/onboarding/questions/${id}` });
            if (response && response.status === 200) {
                setMcqData(response?.data || []);

            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        }
    };

    const reflectionExam = async () => {
        try {
            const response = await APIServices.get({ url: `/onboarding/reflections/${id}` });
            if (response && response.status === 200) {
                setReflectionData(response?.data || []);
            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        }
    }

    const statusUpdate = async () => {
        try {
            const response = await APIServices.post({ url: `/create-qualification-status`, payload: { user_id: user?.id, qualification_id: 15 } });
            if (response && response.status === 200) {
                console.log('Status Updated Successfully');
            }
        } catch (error) {
            console.error('Error fetching module list:', error);
        }
    }


    useEffect(() => {
        mcqExam();
        reflectionExam();
    }, [id, videoQuality]);

    useEffect(() => {
        setActiveStep(parseFloat(id) - 1);
        setSelectedModule(moduleListData.find(module => module.id === parseFloat(id)));

    }, [id, activeStep, moduleListData]);

    useEffect(() => {
        moduleStatus()


    }, []);

    useEffect(() => {
        moduleList();
    }, [videoQuality]);

    useEffect(() => {
        if (parseFloat(id) === 9) {
            moduleFinish();
        }
    }, [id]);

    const moduleFinish = () => {
        statusUpdate();
        navigate('/applicant/done-onboarding');
    }

    const guidelines = [
        {
            title: "Welcome to Your Onboarding!",
            description: "This orientation program is designed to familiarize you with our company. It consists of 8 modules. Please go through each section carefully."
        },
        {
            title: "Module Structure",
            description: "Each of the 8 modules includes one video presentation followed by a 10-item multiple-choice quiz to assess your understanding."
        },
        {
            title: "Passing Score & Progression",
            description: "A score of 80% or higher is required to pass each module's quiz. You must pass the current module before you can proceed to the next one."
        },
        {
            title: "Time Limit",
            description: "You will have 1 minute to answer each multiple-choice question. Please manage your time wisely."
        },



    ];

    return (
        <Suspense fallback={<div></div>}>
            <div>
                {showGuidelines ? (
                    <OnBoardingGuidelines guidelines={guidelines} setShowDashboard={setShowGuidelines} />
                ) : (

                    <div className="flex flex-row lg:flex-row gap-4">
                        <ExamList activeStep={activeStep} shuffledSections={moduleListData} />

                        <div className='w-full flex justify-center items-center self-center'>
                            <OnBoardingTab selectedModule={selectedModule} mcqData={mcqData} reflectionData={reflectionData} videoQuality={videoQuality} setVideoQuality={setVideoQuality} isLoading={isLoading} />
                        </div>
                    </div>


                )}
            </div>
        </Suspense>
    )
}

export default OnBoardingExam
